export default "__VITE_ASSET__D$Bhi_mw__"